module.exports = __webpack_public_path__ + "img/slogo.30591a2a.png";